/**
 * TeacherOverview — My schedule. A calendar of the teacher's own workshops,
 * or on a phone, the list of them under a "Your week ahead" card.
 */
import { useViewport } from '../../../hooks/useViewport';
import MobileTeacherOverview from '../responsive/MobileTeacherOverview';

import TeacherOverviewDesktop from './components/TeacherOverviewDesktop';

export default function TeacherOverview() {
  const { isPhone } = useViewport();
  if (isPhone) return <MobileTeacherOverview />;
  return <TeacherOverviewDesktop />;
}
